import * as React from "react";

type BasicArg = string | number;
type FuncArg = (str: string) => React.ReactNode;
type TokenArg = FuncArg | React.ReactNode;
type FormatterArg = [string, FuncArg];

function isFuncArg(obj: unknown): obj is FuncArg {
	return typeof obj === "function";
}

function isFormatterArg(obj: unknown): obj is FormatterArg {
	return Array.isArray(obj) && typeof obj[0] === "string" && typeof obj[1] === "function";
}

export function formatMessage(template: string, ...args: BasicArg[]): string;
export function formatMessage(template: string, ...args: TokenArg[]): React.ReactNode;
export function formatMessage(template: string, ...args: FormatterArg[]): React.ReactNode;
export function formatMessage(template: string, ...args: unknown[]) {
	let hasReactElement = false;
	let repeatedTokens = 0;
	const mappingTokens: Record<string, React.ReactNode> = {};
	const messages = template
		.split(/(?:\{)([^\{\}]*)(?:})/) // split message into multiple parts with delimiter `{}`
		.map((value, index) => {
			if (index % 2 === 0) {
				return value;
			} else {
				let element: React.ReactNode;

				if (Object.keys(mappingTokens).includes(value)) {
					element = mappingTokens[value];
					repeatedTokens += 1;
				} else {
					const argIndex = Math.floor(index / 2) - repeatedTokens;
					const argToken = args[argIndex];

					element = isFormatterArg(argToken)
						? argToken[1](argToken[0])
						: isFuncArg(argToken)
							? argToken(value)
							: (argToken as React.ReactNode);
				}

				mappingTokens[value] = element;
				if (React.isValidElement(element)) {
					hasReactElement = true;
					return React.cloneElement(element, { key: index });
				} else {
					return element;
				}
			}
		})
		.filter(value => value || typeof value === "number");

	return hasReactElement ? messages : messages.join("");
}
